var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ibx-app-content",class:_vm.classes},[_c('div',{staticClass:"ibx-app-content__filters"},[_vm._v("1")]),_c('div',{staticClass:"ibx-app-content__content"},[_vm._v(" xx ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }